import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseProvider } from "app/shared/helper/http/BaseProvider";

@Injectable()
export class AddOnOrderService extends BaseProvider {

    constructor(public http: HttpClient) {
        super(http);
    }

    getEsimOrderList() {
        //var consumerId = localStorage.getItem(ConstantsKey.CONSUMER_ID);
        var resourceUrl = "zx/orders";
        return this.makeGetCall(resourceUrl);
    }
    
    getLoungeOrders() {
        var resourceUrl = "getLoungeOrders";
        return this.makeGetCall(resourceUrl);
    }
    
    getEsimOrderDetails(orderId) {
        var resourceUrl = "zx/order?id="+orderId;
        return this.makeGetCall(resourceUrl);
    }
    
    getLoungeOrderDetails(orderId) {
        var resourceUrl = "getLoungeOrder?id="+orderId;
        return this.makeGetCall(resourceUrl);
    }

    getESimQrCode(orderId) {
        var resourceUrl = "zx/orderQrCode?id="+orderId;
        return this.makeGetCallTextResponse(resourceUrl);
    }

    getXplorerCardOrders(orderId) {
        var resourceUrl = "xplorerCard/getOrder";
        if(orderId != "") {
            resourceUrl = resourceUrl + "?xplorerId=" +orderId;
        }
        return this.makeGetCall(resourceUrl);
    }    

    getXplorerCardOrdersList() {
        var resourceUrl = "xplorerCard/getAllOrder";
        return this.makeGetCall(resourceUrl);
    }    


}